import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';


import { MenuApiService } from '../menu-api.service';
import {AttributesActions} from '@emm/menu/store/attributes/attributes.actions';

@Injectable({
    providedIn: 'root'
})
export class AttributesEffects {

    loadAll$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AttributesActions.loadAll),
            switchMap(() =>
                this.api.getAllAttributes().pipe(
                    map(attributes => AttributesActions.loadAllSuccess({ attributes })),
                    catchError(error => of(AttributesActions.loadAllFailure({ error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private api: MenuApiService) {}

}
